import { useRouter } from 'next/router';
import React, { FC } from 'react';
import styled from 'styled-components';

import { UserRole } from '~/api/account/accountApiTypes';
import { AuthorLink, UserLink } from '~/atomic/atom/links/dynamicLinks';
import { SCContent } from '~/atomic/page/author/styled';
import { getAuthorSubscribers } from '~/atomic/page/author/subscribers/authorSubscribers.data';
import { authorSubscribersSelector } from '~/atomic/page/author/subscribers/authorSubscribers.selector';
import { EmptySubscribersPage } from '~/atomic/page/author/subscribers/EmptySubscribersPage';
import { PageTitleStyle } from '~/atomic/Typography';
import { Pagination } from '~/feature/pagination/Pagination';
import { paginationSelector } from '~/feature/pagination/pagination.selector';
import { lessThan } from '~/lib/mediaQuery';
import { useAppDispatch, useAppSelector } from '~/store';

import { SCSubscriberCard, SubscriberCard } from './SubscriberCard';

export const AuthorSubscribers: FC = () => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const { subscribers } = useAppSelector(authorSubscribersSelector);
  const { total, perPage } = useAppSelector(paginationSelector);
  const authorUsername = (router.query.authorUsername as string) ?? '';

  if (total < 1) return <EmptySubscribersPage />;

  const changePaginationHandler = () => {
    dispatch(getAuthorSubscribers({ username: authorUsername }));
  };

  return (
    <SCContent>
      <SCPageTitle>{`Подписчики (${total})`}</SCPageTitle>
      <SCSubscribersGrid>
        {
          subscribers.map((subscriber) => (
            <React.Fragment key={subscriber.id}>
              {subscriber.role === UserRole.author ? (
                <AuthorLink username={subscriber.username}>
                  <a>
                    <SubscriberCard subscriber={subscriber} />
                  </a>
                </AuthorLink>
              ) : (
                <UserLink username={subscriber.username}>
                  <a>
                    <SubscriberCard subscriber={subscriber} />
                  </a>
                </UserLink>
              )}
            </React.Fragment>
          ))
        }
      </SCSubscribersGrid>
      {total > perPage && (
        <SCPaginationWrapper>
          <Pagination onChange={changePaginationHandler} />
        </SCPaginationWrapper>
      )}
    </SCContent>
  );
};

const SCPaginationWrapper = styled.div`
  margin: 32px auto 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SCSubscribersGrid = styled.div`
  display: grid;
  grid-gap: 24px;
  grid-template-columns: repeat(auto-fill, 270px);
  
  ${SCSubscriberCard} {
    width: 270px;
  }

  ${lessThan('container-width')} {
    grid-template-columns: repeat(auto-fill, 240px);
    grid-gap: 24px;
    justify-content: center;


    ${SCSubscriberCard} {
      width: 240px;
    }
  }

  ${lessThan('md')} {
    grid-template-columns: repeat(auto-fill, 270px);
    grid-gap: 24px;
    justify-content: center;


    ${SCSubscriberCard} {
      width: 270px;
    }
  }
  
  ${lessThan('sm')} {
    justify-content: center;
  }

  ${lessThan('xs')} {
    justify-content: center;
  }
`;

const SCPageTitle = styled.h1`
  ${PageTitleStyle};
  margin-bottom: 16px;
`;
